const triggerUrls = [
    'atest.if.dk/privat/chatbot',
    'atest.if.dk/privat/ifgpt',
    'atest.minesider.if.dk/dokumenter',
    'atest.minesider.if.dk/oversigt/dokumenter',
    '#ifgpt',
];

const findTriggerUrl = () => {
    const href = window.location.href;
    return triggerUrls.find((url) => href.includes(url));
};

const getSubDomain = () => {
    const href = window.location.href;
    return href.includes('atest') ? 'atest' : 'stest';
};

export const showIfGPT = (): boolean => {
    const triggerUrl = findTriggerUrl();
    if (!triggerUrl) return false;

    const client = document.createElement('ifgpt-web-client');
    document.body.appendChild(client);

    const subDomain = getSubDomain();
    const script = document.createElement('script');
    script.type = 'text/javascript';
    script.src = `https://${subDomain}.if.dk/apps/ifgpt/assets/ifgpt-web-client.js`;
    script.id = 'ifgpt';
    script.async = true;
    document.body.appendChild(script);

    return true;
};
